import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=a45cdf30&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style0 from "./Payments.vue?vue&type=style&index=0&id=a45cdf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45cdf30",
  null
  
)

export default component.exports